export const HWKataToFWHira = {
  ｱ: "あ",
  ｲ: "い",
  ｳ: "う",
  ｴ: "え",
  ｵ: "お",
  ｶ: "か",
  ｷ: "き",
  ｸ: "く",
  ｹ: "け",
  ｺ: "こ",
  ｻ: "さ",
  ｼ: "し",
  ｽ: "す",
  ｾ: "せ",
  ｿ: "そ",
  ﾀ: "た",
  ﾁ: "ち",
  ﾂ: "つ",
  ﾃ: "て",
  ﾄ: "と",
  ﾅ: "な",
  ﾆ: "に",
  ﾇ: "ぬ",
  ﾈ: "ね",
  ﾉ: "の",
  ﾊ: "は",
  ﾋ: "ひ",
  ﾌ: "ふ",
  ﾍ: "へ",
  ﾎ: "ほ",
  ﾏ: "ま",
  ﾐ: "み",
  ﾑ: "む",
  ﾒ: "め",
  ﾓ: "も",
  ﾔ: "や",
  ﾕ: "ゆ",
  ﾖ: "よ",
  ﾗ: "ら",
  ﾘ: "り",
  ﾙ: "る",
  ﾚ: "れ",
  ﾛ: "ろ",
  ﾜ: "わ",
  ｦ: "を",
  ﾝ: "ん",
  ｧ: "ぁ",
  ｨ: "ぃ",
  ｩ: "ぅ",
  ｪ: "ぇ",
  ｫ: "ぉ",
  ｯ: "っ",
  ｬ: "ゃ",
  ｭ: "ゅ",
  ｮ: "ょ",
  ｶﾞ: "が",
  ｷﾞ: "ぎ",
  ｸﾞ: "ぐ",
  ｹﾞ: "げ",
  ｺﾞ: "ご",
  ｻﾞ: "ざ",
  ｼﾞ: "じ",
  ｽﾞ: "ず",
  ｾﾞ: "ぜ",
  ｿﾞ: "ぞ",
  ﾀﾞ: "だ",
  ﾁﾞ: "ぢ",
  ﾂﾞ: "づ",
  ﾃﾞ: "で",
  ﾄﾞ: "ど",
  ﾊﾞ: "ば",
  ﾋﾞ: "び",
  ﾌﾞ: "ぶ",
  ﾍﾞ: "べ",
  ﾎﾞ: "ぼ",
  ﾊﾟ: "ぱ",
  ﾋﾟ: "ぴ",
  ﾌﾟ: "ぷ",
  ﾍﾟ: "ぺ",
  ﾎﾟ: "ぽ",
};

export const FWKataToFWHira = {
  ア: "あ",
  イ: "い",
  ウ: "う",
  エ: "え",
  オ: "お",
  カ: "か",
  キ: "き",
  ク: "く",
  ケ: "け",
  コ: "こ",
  サ: "さ",
  シ: "し",
  ス: "す",
  セ: "せ",
  ソ: "そ",
  タ: "た",
  チ: "ち",
  ツ: "つ",
  テ: "て",
  ト: "と",
  ナ: "な",
  ニ: "に",
  ヌ: "ぬ",
  ネ: "ね",
  ノ: "の",
  ハ: "は",
  ヒ: "ひ",
  フ: "ふ",
  ヘ: "へ",
  ホ: "ほ",
  マ: "ま",
  ミ: "み",
  ム: "む",
  メ: "め",
  モ: "も",
  ヤ: "や",
  ユ: "ゆ",
  ヨ: "よ",
  ラ: "ら",
  リ: "り",
  ル: "る",
  レ: "れ",
  ロ: "ろ",
  ワ: "わ",
  ヲ: "を",
  ン: "ん",
  ァ: "ぁ",
  ィ: "ぃ",
  ゥ: "ぅ",
  ェ: "ぇ",
  ォ: "ぉ",
  ッ: "っ",
  ャ: "ゃ",
  ュ: "ゅ",
  ョ: "ょ",
  ガ: "が",
  ギ: "ぎ",
  グ: "ぐ",
  ゲ: "げ",
  ゴ: "ご",
  ザ: "ざ",
  ジ: "じ",
  ズ: "ず",
  ゼ: "ぜ",
  ゾ: "ぞ",
  ダ: "だ",
  ヂ: "ぢ",
  ヅ: "づ",
  デ: "で",
  ド: "ど",
  バ: "ば",
  ビ: "び",
  ブ: "ぶ",
  ベ: "べ",
  ボ: "ぼ",
  パ: "ぱ",
  ピ: "ぴ",
  プ: "ぷ",
  ペ: "ぺ",
  ポ: "ぽ",
};
